import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangepassowrdComponent } from '../changepassowrd/changepassowrd.component';
import { MatDialog } from '@angular/material';
import { AppService } from 'src/app/appservice.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UpdateOrgComponent } from '../update-org/update-org.component';
import { QuillEditorComponent } from 'ngx-quill';
import { debounceTime, distinctUntilChanged, startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ElectronService } from 'ngx-electron';
import { RestartDialogComponent } from '../restart-dialog/restart-dialog.component';
import { MessageBoxComponent } from 'src/app/shared/message-box/message-box.component';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.css']
})
export class GeneralSettingsComponent implements OnInit {
  panelOpenState = false;
  settingsForm: FormGroup;
  backupForm: FormGroup;
  orgForm: FormGroup;
  marginForm: FormGroup;
  invoiceNumberForm: FormGroup;
  guestform: FormGroup;
  dfSettings: FormGroup;
  guest_enable = false;
  default_page = '1';
  lastbackuptaken = '-';
  users: any[] = [];

  shippingPrint = 'Auto';
  shippingPrintOptions: string[] = ['No', 'Yes', 'Auto'];

  isAddress = false;
  isSubmitting = false;
  filteredOptions: Observable<string[]>;
  states: any;
  taxgroups: any;
  UOMs: any;
  numberyear: number[] = [0, 1];

  @ViewChild('orgnameformatted', { static: false }) editor: QuillEditorComponent;

  constructor(public service: AppService, public eservice: ElectronService, public dialog: MatDialog, public router: Router) {
    const gstpattern = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
    const panpattern = '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$';
    const mobilepattern = '^(?:(?:\\+|0{0,2})91(\\s*[\\ -]\\s*)?|[0]?)?[56789]\\d{9}|(\\d[ -]?){10}\\d$';

    if (!this.service.isadmin) {
      this.router.navigate(['/invoice/0']);
    }

    this.numberyear = [];

    for (let index = (new Date().getFullYear()) - 5; index <= (new Date().getFullYear() + 1); index++) {
      this.numberyear.push(index);
    }

    this.settingsForm = new FormGroup({
      username: new FormControl(''),
      org: new FormControl('')
    });

    this.backupForm = new FormGroup({
      backuppath: new FormControl(''),
      lastbackup: new FormControl('')
    });

    this.invoiceNumberForm = new FormGroup({
      InvoiceNoFormat: new FormControl('{FYY}/{Value}'),
      InvoiceNoYear: new FormControl((new Date()).getFullYear()),
      InvoiceNoValue: new FormControl('1')
    });

    this.guestform = new FormGroup({
      guest_password: new FormControl()
    });

    this.loadUsers();


    this.invoiceNumberForm.controls.InvoiceNoYear.valueChanges.subscribe(x => { this.changeNumYear(x); });

    this.changeNumYear(this.invoiceNumberForm.controls.InvoiceNoYear.value);

    this.orgForm = new FormGroup({
      name: new FormControl(),
      nameformatted: new FormControl(),
      shortname: new FormControl(),
      slogan: new FormControl(),
      phone: new FormControl(),
      mobile: new FormControl('', [Validators.pattern(mobilepattern)]),
      email: new FormControl(),
      website: new FormControl(),
      addressline1: new FormControl(),
      addressline2: new FormControl(),
      landmark: new FormControl(),
      pinCode: new FormControl(),
      city: new FormControl(),
      stateId: new FormControl(),
      statename: new FormControl(this.service.df_state),
      country: new FormControl('India'),
      gstin: new FormControl('', [Validators.pattern(gstpattern)]),
      pan: new FormControl('', [Validators.pattern(panpattern)]),
      bankname: new FormControl(),
      bankacno: new FormControl(),
      branch: new FormControl(),
      ifsc: new FormControl(),
      upiid: new FormControl(),
      demo1: new FormControl(),
      demo2: new FormControl(),
      demo3: new FormControl(),
      demo4: new FormControl(),
      demo5: new FormControl(),
      password: new FormControl(),
      terms: new FormControl(),
      df_tax: new FormControl(),
      df_hnscode: new FormControl(),
      df_uom: new FormControl(),
      uom: new FormControl(),
      tax_inc: new FormControl(),
      istaxindividual: new FormControl(),
      rounding: new FormControl('1'),
      dfPlaceofSupply: new FormControl('')
    });

    this.dfSettings = new FormGroup({
      printShipping: new FormControl('Auto'),
      enableTransportation: new FormControl(true),
      dfPlaceofSupply: new FormControl('')
    });

    this.setMarginForm();

    this.service.getRequest('api/getTaxGroups').subscribe(x => {
      this.taxgroups = x;
    });

    this.service.getRequest('api/getUOM').subscribe(x => {
      this.UOMs = x;
      this.filteredOptions = this.orgForm.controls.uom.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      for (let i = 0; i < x.length; i++) {
        if (x[i].name === this.service.df_uom) {
          this.orgForm.controls.uom.patchValue(x[i]);
          break;
        }
      }
    });

    this.service.getRequest('api/keyvalue/margins').subscribe(x => {
      if (x !== null) {
        this.marginForm.controls.itop.patchValue(x.itop);
        this.marginForm.controls.ibottom.patchValue(x.ibottom);
        this.marginForm.controls.ileft.patchValue(x.ileft);
        this.marginForm.controls.iright.patchValue(x.iright);

        this.marginForm.controls.ctop.patchValue(x.ctop);
        this.marginForm.controls.cbottom.patchValue(x.cbottom);
        this.marginForm.controls.cleft.patchValue(x.cleft);
        this.marginForm.controls.cright.patchValue(x.cright);
      }
    });



    this.service.getRequest('api/keyvalue/dfPlaceofSupply').subscribe(x => {
      if (x !== null) {
        this.orgForm.controls.dfPlaceofSupply.patchValue(x.dfPlaceofSupply);
      }
    });

    this.service.getRequest('api/org')
      .subscribe(o => {
        this.orgForm.controls.name.patchValue(o.name);
        this.orgForm.controls.nameformatted.patchValue(o.nameformatted);
        this.orgForm.controls.shortname.patchValue(o.shortname);
        this.orgForm.controls.slogan.patchValue(o.slogan);
        this.orgForm.controls.phone.patchValue(o.phone);
        this.orgForm.controls.mobile.patchValue(o.mobile);
        this.orgForm.controls.email.patchValue(o.email);
        this.orgForm.controls.website.patchValue(o.website);
        this.orgForm.controls.addressline1.patchValue(o.addressline1);
        this.orgForm.controls.addressline2.patchValue(o.addressline2);
        this.orgForm.controls.landmark.patchValue(o.landmark);
        this.orgForm.controls.pinCode.patchValue(o.pinCode);
        this.orgForm.controls.city.patchValue(o.city);
        this.orgForm.controls.stateId.patchValue(o.stateId);
        this.orgForm.controls.country.patchValue(o.country);
        this.orgForm.controls.gstin.patchValue(o.gstin);
        this.orgForm.controls.pan.patchValue(o.pan);
        this.orgForm.controls.bankname.patchValue(o.bankname);
        this.orgForm.controls.ifsc.patchValue(o.ifsc);
        this.orgForm.controls.bankacno.patchValue(o.bankacno);
        this.orgForm.controls.branch.patchValue(o.branch);
        this.orgForm.controls.upiid.patchValue(o.upiid);
        this.orgForm.controls.terms.patchValue(o.terms);
        this.orgForm.controls.df_hnscode.patchValue(o.df_hnscode);
        this.orgForm.controls.df_uom.patchValue(o.df_uom);
        this.orgForm.controls.df_tax.patchValue(o.df_tax);
        this.orgForm.controls.tax_inc.patchValue(o.tax_inc);
        this.orgForm.controls.istaxindividual.patchValue(o.istaxindividual);
        this.orgForm.controls.rounding.patchValue(o.rounding == null ? true : o.rounding);
        this.guest_enable = o.user.guest_enabled;
      });

    this.default_page = this.service.getlocalitem('default_page') != null ? this.service.getlocalitem('default_page') : '1';

    this.service.getRequest('api/keyvalue/backupdetail').subscribe((data) => {
      this.backupForm.controls.backuppath.patchValue(data.backuppath);
      this.backupForm.controls.lastbackup.patchValue(data.lastbackup);
      if (data.lastbackup !== null && data.lastbackup !== '') {
        this.lastbackuptaken = this.getFormattedDate(new Date(data.lastbackup));
      }
    });
  }

  getFormattedDate(date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-'
      + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
  }

  setMarginForm() {
    this.marginForm = new FormGroup({
      itop: new FormControl('5mm'),
      ibottom: new FormControl('5mm'),
      ileft: new FormControl('5mm'),
      iright: new FormControl('5mm'),
      ctop: new FormControl('33mm'),
      cbottom: new FormControl('auto'),
      cleft: new FormControl('40mm'),
      cright: new FormControl('auto'),
      printShipping: new FormControl('auto')
    });
    return false;
  }

  ngOnInit() {
    // this.editor
    // .onContentChanged
    // .pipe(
    //   debounceTime(400),
    //   distinctUntilChanged()
    // )
    // .subscribe((data) => {
    //   // tslint:disable-next-line:no-console
    //   console.log('view child + directly subscription', data);
    //   // alert(data.content);
    // });
  }

  save_defaultpage() {
    this.service.setlocalitem('default_page', this.default_page);
  }

  saveguest() {
    this.service.getRequestData('api/guest_update/', this.guestform.value).subscribe((data) => {
      console.log(data);
      if (data.Success) {
        this.service.sendMessage('SaveSuccess');
      } else {
        if (data.Error) {
          this.service.sendMessage(data.Error);
        } else {
          this.service.sendMessage(data.message);
        }
      }
    },
      (err) => {
        console.log('Detail update failed : ' + err);
        this.service.sendMessage('Oops');
      });
  }

  displayFn(item: any): string {
    this.UOMs = item;
    return item ? item.name : (item ? item.id.toString() : null);
  }

  openChangePassDialog(): boolean {
    const dialogRef = this.dialog.open(ChangepassowrdComponent, {
      width: '600px',
      data: {
        name: ''
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result);

      }
    });

    return false;
  }

  private _filter(value: any): string[] {
    const filterValue = value.name ? value.name.toLowerCase() : value.toLowerCase();

    return this.UOMs.filter(option => (option.description.toLowerCase().includes(filterValue) ||
      option.name.toLowerCase().includes(filterValue)));
  }
  onSubmitOrg() {
    try {
      this.isSubmitting = true;
      this.orgForm.value.df_uom = this.orgForm.value.uom.name;
      this.service.df_uom = this.orgForm.value.uom.name;
      if (this.orgForm.valid) {
        this.service.getRequestData('api/org', this.orgForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            const dfsupply: any = {};
            dfsupply.dfPlaceofSupply = this.orgForm.value.dfPlaceofSupply;

            this.service.getRequestData('api/keyvalue/dfPlaceofSupply',
              dfsupply)
              .subscribe((d) => {
                console.log('dfpos :' + d);
              });


            this.service.sendMessage('SaveSuccess');
            // if (this.eservice.isElectronApp) {
            this.router.navigate(['/settings/restart-app']);
            this.service.islogin = false;
            // }
          } else {
            this.service.sendMessage(data.Error);
          }
        },
          (err) => {
            console.log('Detail update failed : ' + err);
            this.service.sendMessage('Oops');
          });
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }

  changeNumYear(_year: any) {
    this.service.getRequest('api/getNumber/' + this.invoiceNumberForm.controls.InvoiceNoYear.value).subscribe((data) => {
      this.invoiceNumberForm.controls.InvoiceNoValue.patchValue(data.value);
      this.invoiceNumberForm.controls.InvoiceNoFormat.patchValue(data.format);
    });
  }

  setBackup() {
    try {
      this.isSubmitting = true;
      if (this.backupForm.valid) {
        this.service.getRequestData('api/keyvalue/backupdetail', this.backupForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.service.sendMessage('SaveSuccess');
          } else {
            this.service.sendMessage(data.Error);
          }
        });
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }

  backupNow() {
    try {
      this.isSubmitting = true;
      if (this.backupForm.valid) {
        this.service.backup(1);
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }

  setNumberForm() {
    try {
      this.isSubmitting = true;
      if (this.invoiceNumberForm.valid) {

        const dialogRef = this.dialog.open(MessageBoxComponent, {
          width: '350px', data: {
            title: 'Confirm',
            message: 'Settings.ConfirmNumberUpdate',
            input: 'Password',
            inputtype: 'password'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.service.getRequestData('api/setNumber/' + result, this.invoiceNumberForm.value).subscribe((data) => {
              console.log(data);
              if (data.Success) {
                this.service.sendMessage('SaveSuccess');
              } else {
                if (data.Error) {
                  this.service.sendMessage(data.Error);
                } else {
                  this.service.sendMessage(data.message);
                }
              }
            },
              (err) => {
                console.log('Detail update failed : ' + err);
                this.service.sendMessage('Oops');
              });
          }
        });
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }

  saveMargins() {
    try {
      this.isSubmitting = true;
      if (this.marginForm.valid) {
        this.service.getRequestData('api/keyvalue/defaultSettings', this.dfSettings.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.service.sendMessage('SaveSuccess');
          } else {
            this.service.sendMessage(data.Error);
          }
        });

        this.service.getRequestData('api/keyvalue/margins', this.marginForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.service.sendMessage('SaveSuccess');
          } else {
            this.service.sendMessage(data.Error);
          }
        },
          (err) => {
            console.log('Detail update failed : ' + err);
            this.service.sendMessage('Oops');
          });
      } else {
        this.service.sendMessage('User.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }
  openChangeOrgDialog(): boolean {
    const dialogRef = this.dialog.open(UpdateOrgComponent, {
      width: '600px',
      data: {
        name: this.settingsForm.controls.username.value
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result);

      }
    });

    return false;
  }

  loadUsers() {
    this.service.getRequest('api/admin/users').subscribe(data => {
      this.users = data;
    });
  }

  editUser(user) {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '450px',
      data: { user: user }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadUsers();
      }
    });
  }

  addUser() {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '450px',
      data: { user: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadUsers();
      }
    });
  }

  deleteUser(id) {
    if (confirm('Are you sure you want to deactivate this user?')) {
      this.service.deleteRequest('api/admin/users/' + id).subscribe(data => {
        if (data.success) {
          this.service.sendMessage('User Deactivated Successfully');
          this.loadUsers();
        } else {
          this.service.sendMessage(data.message || 'Error deleting user');
        }
      });
    }
  }
}
